import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ImagePreloadService {
  private readonly seen = new Set<string>();

  preloadAll(urls: readonly string[], opts?: { concurrency?: number }): void {
    const concurrency = Math.max(1, Math.min(8, opts?.concurrency ?? 4));
    const queue = urls.filter((u) => !!u && !this.seen.has(u));
    queue.forEach((u) => this.seen.add(u));

    if (queue.length === 0) return;

    let idx = 0;
    const pump = (): void => {
      if (idx >= queue.length) return;
      const url = queue[idx++];
      const img = new Image();
      img.decoding = "async";
      img.loading = "eager";
      img.src = url;
      // Continue regardless of success/failure.
      img.onload = () => pump();
      img.onerror = () => pump();
    };

    for (let i = 0; i < Math.min(concurrency, queue.length); i++) pump();
  }
}

